/**
 * @generated SignedSource<<55a4c848c87ddd56cdbb3740d41ca4ff>>
 * @relayHash 54fc2e3906ba324b49b9344286b1c079
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 54fc2e3906ba324b49b9344286b1c079

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "documents"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documents",
        "variableName": "documents"
      }
    ],
    "concreteType": "SortedDocument",
    "kind": "LinkedField",
    "name": "sortDocuments",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sortedDocumentId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DocumentsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DocumentsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "54fc2e3906ba324b49b9344286b1c079",
    "metadata": {},
    "name": "DocumentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "13856951597a5bfbd7ff0044149a794e";

export default node;
